module.exports = __webpack_public_path__ + "img/streamline_jp.3a8f18e.jpg";